import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { Provider } from './context';
const containerIsPhoneCss = "c12k4mj6";
const containerCss = "c3gljg6";
const Container = forwardRef((props, ref) => {
  const {
    isPhone,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const MainContainer = ({
  children
}) => {
  const [isWide, setIsWide] = useState(false);
  const [zeroPadding, setZeroPadding] = useState(false);
  const [headerBorderBottom, setHeaderBorderBottom] = useState(false);
  const isPhone = useDeviceType('isPhone');
  return <Provider value={{
    isWide,
    setIsWide,
    zeroPadding,
    setZeroPadding,
    headerBorderBottom,
    setHeaderBorderBottom
  }}>
      <Container isPhone={isPhone}>
        {children}
      </Container>
    </Provider>;
};

require("./container.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./container.js");